/* Happy Pointer Farms — cart drawer, purchase selector, situation picker */
(function () {
  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ------------- Situation picker (delegated, resilient) ------------- */
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-situation]');
    if (!card) return;
    var root = card.closest('[data-situations]');
    if (!root) return;
    root.querySelectorAll('[data-situation]').forEach(function (c) {
      c.setAttribute('aria-pressed', c === card ? 'true' : 'false');
    });
    var out = root.querySelector('[data-situation-framing]');
    if (out) out.textContent = card.getAttribute('data-framing') || '';
  });

  /* ---------------- Cart drawer ---------------- */
  var drawer = {
    el: null,
    overlay: null,
    open: function () {
      if (!this.el) return;
      this.el.classList.add('open');
      this.overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('open');
      this.overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  function purchaseLabel(item) {
    if (item.selling_plan_allocation) {
      return item.selling_plan_allocation.selling_plan.name;
    }
    var props = item.properties || {};
    if (props['Purchase type']) return props['Purchase type'];
    return 'One-time purchase';
  }

  function renderCart(cart) {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-subtotal]');
    var counts = document.querySelectorAll('[data-cart-count]');
    var checkout = document.querySelector('[data-cart-checkout]');
    if (!body) return;

    counts.forEach(function (n) {
      n.textContent = cart.item_count;
      n.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (!cart.items.length) {
      body.innerHTML =
        '<p class="charcoal">Your cart is empty. The first run of Hip &amp; Joint Support Advanced is open for pre-order.</p>';
      if (foot) foot.textContent = money(0);
      if (checkout) checkout.setAttribute('disabled', 'disabled');
      return;
    }
    if (checkout) checkout.removeAttribute('disabled');

    body.innerHTML = cart.items
      .map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_180x$1$2') + '" alt="" width="72" height="72">'
          : '<div style="width:72px;height:72px;border-radius:6px;background:var(--secondary)"></div>';
        return (
          '<div class="cart-line" data-key="' + item.key + '">' +
          img +
          '<div>' +
          '<p class="type">' + purchaseLabel(item) + '</p>' +
          '<p style="font-family:var(--font-display);font-size:1.05rem;">' + item.product_title + '</p>' +
          '<p class="small charcoal">' + money(item.final_line_price) + '</p>' +
          '<div class="qty">' +
          '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty="' + item.key + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<br><button type="button" class="remove" data-qty="' + item.key + '" data-to="0">Remove</button>' +
          '</div></div>'
        );
      })
      .join('');

    if (foot) foot.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function addToCart(payload) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return fetchCart();
      })
      .then(function () { drawer.open(); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    drawer.el = document.querySelector('[data-cart-drawer]');
    drawer.overlay = document.querySelector('[data-cart-overlay]');

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-cart-open]');
      if (openBtn) { e.preventDefault(); drawer.open(); fetchCart(); return; }

      if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-overlay]')) {
        drawer.close();
        return;
      }

      var qtyBtn = e.target.closest('[data-qty]');
      if (qtyBtn) {
        changeLine(qtyBtn.getAttribute('data-qty'), parseInt(qtyBtn.getAttribute('data-to'), 10));
        return;
      }

      var burger = e.target.closest('[data-menu-toggle]');
      if (burger) {
        var nav = document.querySelector('[data-mobile-nav]');
        if (nav) nav.classList.toggle('open');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drawer.close();
    });

    /* ------------- Purchase type selector ------------- */
    document.querySelectorAll('[data-purchase-form]').forEach(function (form) {
      var options = form.querySelectorAll('[data-purchase-option]');
      function sync() {
        options.forEach(function (opt) {
          var input = opt.querySelector('input[type="radio"]');
          opt.classList.toggle('selected', input.checked);
        });
        var checked = form.querySelector('input[name="purchase_type"]:checked');
        if (!checked) return;
        var plan = checked.getAttribute('data-selling-plan') || '';
        var planField = form.querySelector('[name="selling_plan"]');
        if (planField) planField.value = plan;
        var propField = form.querySelector('[data-purchase-property]');
        if (propField) {
          propField.value = checked.getAttribute('data-label') || '';
          propField.disabled = !!plan; /* selling plan already labels the line */
        }
      }
      form.addEventListener('change', sync);
      sync();

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-button]');
        var original = btn ? btn.textContent : '';
        if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding…'; }
        var formData = new FormData(form);
        var payload = { items: [{ id: formData.get('id'), quantity: 1, properties: {} }] };
        var plan = formData.get('selling_plan');
        if (plan) payload.items[0].selling_plan = plan;
        var label = formData.get('properties[Purchase type]');
        if (label) payload.items[0].properties['Purchase type'] = label;
        addToCart(payload)
          .catch(function (err) { alert(err.message || 'Could not add to cart.'); })
          .then(function () { if (btn) { btn.removeAttribute('disabled'); btn.textContent = original; } });
      });
    });

    fetchCart();
  });
})();
